/* Stable checkout identity survives uncertain responses and reloads in this tab. */
(function(scope){'use strict';if(scope.EFPrepareCheckout)return;const memory=new Map();scope.EFPrepareCheckout=async function(payload){const props={...(payload.properties||{})};const oldId=props._config_id;delete props._config_id;const note=oldId?String(payload.customer_note||'').split(oldId).join('[configuration]'):String(payload.customer_note||'');const semantic=JSON.stringify({variant_id:String(payload.variant_id),quantity:payload.quantity,calculated_price:payload.calculated_price,configuration:payload.configuration,properties:props,customer_note:note,customer_email:payload.customer_email||'',color_photo:payload.color_photo||'',color_photo_name:payload.color_photo_name||''});const bytes=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(semantic));const hash=Array.from(new Uint8Array(bytes)).map(v=>v.toString(16).padStart(2,'0')).join('');const key='ef-checkout-request:'+hash;let id=memory.get(key);try{id=id||sessionStorage.getItem(key);}catch(_){}if(!id){id='efc-'+crypto.randomUUID();memory.set(key,id);try{sessionStorage.setItem(key,id);}catch(_){}}payload.request_id=id;payload.properties={...props,_config_id:id};if(oldId)payload.customer_note=String(payload.customer_note||'').split(oldId).join(id);return payload;};})(window);

/* ExceptionalFire — Lexington Custom Mantel Builder
   EF_LXC_MSRP_20260911: exact widths in stock finishes use verified manufacturer MSRP.
   sizes[].std = standard MSRP / native listing price; sizes[].price = preserved custom base.
   Custom cuts, extensions and Custom Color Match retain their existing totals and use the Draft Order Worker.
   EF_LXC_MIN30_20260911: every style can be cut down to 30" (MIN_WIDTH replaces the per-model minimum).
   3 steps: Style -> Width -> Review. Custom pricing via Draft Order Worker.
   Pricing rules:
     - exact standard width  -> standard price
     - custom width in range (< maxStd) -> preserved custom base of next size UP + $400
     - combo (> maxStd, to maxStd+48, cap 120) -> maxStdPrice * (1 + 0.65*numExtensions)
       (each 24" extension = 65% of largest standard price; decorative bracket set included)
*/
(function () {
  'use strict';
  var root = document.getElementById('lxc-root');
  if (!root) return;
  var DATA;
  try { DATA = JSON.parse(document.getElementById('ef-lxc-data').textContent); } catch (e) { return; }
  var SWATCH = {}; try { SWATCH = JSON.parse(document.getElementById('ef-lxc-swatches').textContent); } catch (e) {}
  var FG = {}; try { FG = JSON.parse(document.getElementById('ef-lxc-fg').textContent); } catch (e) {}
  var GLBMAP = {}; try { GLBMAP = JSON.parse(document.getElementById('ef-lxc-glb').textContent); } catch (e) {}
  var USDZMAP = {}; try { USDZMAP = JSON.parse(document.getElementById('ef-lxc-usdz').textContent); } catch (e) {}
  var MODEL_GALLERY = {}; try { MODEL_GALLERY = JSON.parse(document.getElementById('ef-lxc-model-gallery').textContent); } catch (e) {}
  var VARIANTS = {}; try { VARIANTS = JSON.parse(document.getElementById('ef-lxc-variants').textContent); } catch (e) {}
  var PTITLES = {}; try { PTITLES = JSON.parse(document.getElementById('ef-lxc-ptitles').textContent); } catch (e) {}
  var VISUAL_ASSETS = {}; try { VISUAL_ASSETS = JSON.parse(document.getElementById('ef-lxc-visual-assets').textContent); } catch (e) {}
  var SURCHARGE_VARIANT = 42430856986706; // $1 "EF Mantel Made-to-Order Fee" — qty = $ of surcharge
  var WORKER = window.EF_DRAFT_ORDER_WORKER_URL || 'https://ef-draft-order.danielzajacus.workers.dev';
  var MIN_WIDTH = 30;      // every style can be cut down to 30" (EF_LXC_MIN30_20260911)
  var CUSTOM_FEE = 400;    // custom-width cut (350 x 1.15, kept round so base + fee stays on x49/x99) EF_LXC_PRICE15_20260911
  var EXT_FACTOR = 0.65;   // each extension = 65% of largest standard price
  var EXT_INCHES = 24;
  var MAX_COMBO_EXT = 2;
  var CUSTOM_FINISH_FEE = 350;       // custom color match (300 x 1.15)
  var CF_LABEL = 'Custom Color Match';
  var BRACKET_MODELS = VISUAL_ASSETS.bracketModels || {};
  function previewText(value) { return String(value).replace(/[&<>"']/g, function (c) { return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; }); }
  function validBracket(color) { return color === 'Black' || color === 'Bronze'; }

  function priced() {
    var c = calc(state.model, state.width, state.finish);
    var ff = (state.finish === CF_LABEL) ? CUSTOM_FINISH_FEE : 0;
    return { c: c, ff: ff, total: c.price + ff };
  }
  function toggleColorRef(show) {
    var wrap = root.querySelector('#lxc-colorref-wrap');
    if (wrap) wrap.style.display = show ? 'block' : 'none';
  }

  var state = { model: null, width: null, finish: null, finishChosen: false, bracketColor: null, qty: 1 };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };
  // nearest "pretty" price ending in 49 or 99
  function nice(x) { var b = Math.floor(x / 50) * 50, c = [b - 1, b + 49, b + 99]; c.sort(function (p, q) { return Math.abs(p - x) - Math.abs(q - x); }); return c[0]; }
  var fmtW = function (w) { return (w % 1 === 0 ? w : w.toFixed(1)) + '"'; };
  function parseInches(s) {
    if (!s) return 0; s = String(s).replace(/[″"]/g, '').trim();
    var map = { '½': .5, '¼': .25, '¾': .75, '⅜': .375, '⅝': .625, '⅛': .125, '⅞': .875, '⅓': .333, '⅔': .667 };
    var m = s.match(/^(\d+)?\s*([½¼¾⅜⅝⅛⅞⅓⅔])$/);
    if (m) return (parseInt(m[1] || '0', 10)) + (map[m[2]] || 0);
    var f = parseFloat(s); return isNaN(f) ? 0 : f;
  }
  // Live scale visualizer — mantel beam drawn to scale beside a 6ft person
  function updateScale(m, w) {
    var el = root.querySelector('#lxc-scale'); if (!el) return;
    var PXI = 1.7, H = 72 * PXI, floorY = H + 8;
    var bw = w * PXI, bh = Math.max(4, parseInches(m.height)) * PXI;
    var humanW = 26 * PXI, gap = 18, beamX = humanW + gap, beamY = floorY - 0.46 * H - bh;
    var vbW = Math.max(beamX + bw + 10, 260), vbH = floorY + 24, hx = humanW / 2;
    var s = '<svg viewBox="0 0 ' + vbW + ' ' + vbH + '" width="100%" preserveAspectRatio="xMinYMax meet" role="img" aria-label="Scale preview">';
    s += '<line x1="0" y1="' + floorY + '" x2="' + vbW + '" y2="' + floorY + '" stroke="#DED6CB" stroke-width="1.5"/>';
    s += '<g fill="#d8cfc1"><circle cx="' + hx + '" cy="' + (floorY - H + 9 * PXI) + '" r="' + (5 * PXI) + '"/>';
    s += '<rect x="' + (hx - 6 * PXI) + '" y="' + (floorY - H + 15 * PXI) + '" width="' + (12 * PXI) + '" height="' + (H - 15 * PXI) + '" rx="' + (5 * PXI) + '"/></g>';
    s += '<text x="' + hx + '" y="' + (floorY + 16) + '" text-anchor="middle" font-size="10" fill="#9b9183">6 ft</text>';
    s += '<rect x="' + beamX + '" y="' + beamY + '" width="' + bw + '" height="' + bh + '" rx="3" fill="#6b4f34"/>';
    s += '<rect x="' + beamX + '" y="' + beamY + '" width="' + bw + '" height="' + Math.min(bh, 4) + '" fill="#8A6A43"/>';
    s += '<text x="' + (beamX + bw / 2) + '" y="' + (beamY - 7) + '" text-anchor="middle" font-size="12" fill="#1E1E1B" font-weight="700">' + fmtW(w) + '</text>';
    s += '</svg>';
    el.innerHTML = s;
    var cap = root.querySelector('#lxc-sizeref'); if (cap) cap.textContent = '📏 Shown to scale next to a 6 ft adult · ' + m.depth + ' deep × ' + m.height + ' tall';
  }
  // gallery for a model+finish (uses finish-specific white-bg set when available)
  function galleryFor(m, finish) {
    if (m.finishGalleries && finish && m.finishGalleries[finish]) return m.finishGalleries[finish];
    return (m.gallery && m.gallery.length) ? m.gallery : [m.img];
  }
  // Existing size-specific GLBs are references, independent of the configured order width.
  var galImgs = [], galModels = [], galIdx = 0, galleryBound = null;
  var modelViewer = root.querySelector('#lxc-mv'), modelNote = root.querySelector('#lxc-mvnote'),
      modelCap = root.querySelector('#lxc-scalecap'), modelPanel = document.createElement('div'),
      modelParking = document.createElement('div'), modelStatus = document.createElement('p');
  modelParking.hidden = true; root.querySelector('.lxc__media').appendChild(modelParking);
  modelPanel.className = 'lxc-model-panel'; modelParking.appendChild(modelPanel);
  [modelViewer, modelNote, modelCap].forEach(function (el) { if (el) modelPanel.appendChild(el); });
  modelStatus.className = 'lxc-model-status'; modelStatus.setAttribute('role', 'status');
  modelPanel.appendChild(modelStatus);
  var modelFallback = document.createElement('button'); modelFallback.type = 'button';
  modelFallback.className = 'lxc-model-fallback'; modelFallback.textContent = 'View photos'; modelFallback.hidden = true;
  modelFallback.addEventListener('click', function () {
    setGal(0);
  });
  modelPanel.appendChild(modelFallback);
  function modelsFor(m, finish) {
    var map = MODEL_GALLERY[m.name] || {}, shown = finish;
    if (!map[shown] || !map[shown].length) {
      shown = (m.finishes || []).concat(Object.keys(map)).filter(function (f) { return map[f] && map[f].length; })[0];
    }
    return (map[shown] || []).map(function (item) { return Object.assign({}, item, { finish: shown }); });
  }
  function syncModelSlide() {
    var item = galModels[galIdx - galImgs.length], pill = root.querySelector('#lxc-arpill');
    if (!item) {
      if (modelPanel.parentNode !== modelParking) modelParking.appendChild(modelPanel);
      if (pill) pill.hidden = true;
      return;
    }
    var slide = root.querySelector('#lxc-gallery-slides').children[galIdx];
    if (!slide || !modelViewer) return;
    if (modelPanel.parentNode !== slide) slide.appendChild(modelPanel);
    modelViewer.style.display = '';
    modelViewer.setAttribute('alt', state.model.name + ', ' + item.finish + ', ' + fmtW(item.width) + ' wide 3D reference');
    modelNote.hidden = false;
    modelNote.textContent = fmtW(item.width) + ' wide · ' + item.finish;
    modelCap.textContent = 'Fixed-size 3D reference' + (state.width !== item.width ? '; selected width ' + fmtW(state.width) : '') + '. Drag to rotate · pinch to zoom.';
    if (modelViewer.getAttribute('src') !== item.glb) {
      delete modelViewer.dataset.loadedSrc;
      modelViewer.classList.add('is-loading'); modelViewer.setAttribute('aria-busy', 'true');
      modelStatus.textContent = 'Loading 3D preview…'; modelFallback.hidden = true;
      modelViewer.setAttribute('poster', item.poster || state.model.img);
      if (item.usdz) modelViewer.setAttribute('ios-src', item.usdz); else modelViewer.removeAttribute('ios-src');
      modelViewer.setAttribute('src', item.glb);
    }
    if (pill) {
      pill.hidden = modelViewer.dataset.loadedSrc !== item.glb;
      pill.setAttribute('data-ar-glb', item.glb); pill.setAttribute('data-ar-usdz', item.usdz || '');
      pill.setAttribute('data-product-title', state.model.name + ' — ' + fmtW(item.width) + ' 3D reference');
      pill.setAttribute('aria-label', 'View the ' + fmtW(item.width) + ' reference model in your room');
      pill.querySelector('.lxc-arpill__label').textContent = 'View ' + fmtW(item.width) + ' in your room';
    }
  }
  if (modelViewer) {
    modelViewer.addEventListener('load', function (event) {
      // model-viewer v4 may finish an earlier source's event after a rapid selection.
      if (!event.detail || event.detail.url !== modelViewer.getAttribute('src')) return;
      modelViewer.dataset.loadedSrc = event.detail.url;
      modelViewer.classList.remove('is-loading'); modelViewer.removeAttribute('aria-busy');
      modelStatus.textContent = ''; modelFallback.hidden = true;
      syncModelSlide();
    });
    modelViewer.addEventListener('error', function (event) {
      if (event.detail && event.detail.type === 'loadfailure' && modelViewer.loaded && modelViewer.dataset.loadedSrc === modelViewer.getAttribute('src')) return;
      delete modelViewer.dataset.loadedSrc; modelViewer.classList.remove('is-loading');
      modelViewer.removeAttribute('aria-busy'); modelStatus.textContent = '3D preview could not load. Photos are still available.';
      modelFallback.hidden = false; var pill = root.querySelector('#lxc-arpill'); if (pill) pill.hidden = true;
    });
  }
  function bindModelGallery() {
    if (!window.EFGallery || galleryBound === window.EFGallery.main) return;
    galleryBound = window.EFGallery.main;
    galleryBound.on('slideChange', function () { galIdx = galleryBound.activeIndex; syncModelSlide(); });
    window.EFGallery.thumbs.on('update slidesLengthChange', labelModelThumbs);
  }
  function labelModelThumbs() {
    root.querySelectorAll('.lxc-model-thumb').forEach(function (thumb) {
      thumb.setAttribute('aria-label', thumb.dataset.modelLabel);
    });
  }
  function setGal(i) {
    var count = galImgs.length + galModels.length; if (!count) return;
    galIdx = (i + count) % count; bindModelGallery();
    if (window.EFGallery) window.EFGallery.main.slideTo(galIdx);
    syncModelSlide();
  }
  function renderGallery(imgs) {
    if (!imgs || !imgs.length) return;
    modelParking.appendChild(modelPanel);
    galImgs = imgs.slice(); galModels = modelsFor(state.model, state.finish); galIdx = 0;
    var slides = root.querySelector('#lxc-gallery-slides'), th = root.querySelector('#lxc-thumbs');
    var mainImg = root.querySelector('#lxc-m-img');
    slides.replaceChildren(); th.replaceChildren();
    imgs.forEach(function (src, i) {
      var slide = document.createElement('div'); slide.className = 'swiper-slide ef-pd-slide'; slide.dataset.mediaType = 'image';
      var img = i === 0 ? mainImg : document.createElement('img');
      img.src = src; img.alt = (state.model ? state.model.name : 'Lexington mantel') + ' — photo ' + (i + 1); img.loading = i ? 'lazy' : 'eager';
      slide.appendChild(img); slides.appendChild(slide);
      var t = document.createElement('button'); t.type = 'button'; t.className = 'swiper-slide ef-pd-thumb lxc-thumb'; t.setAttribute('aria-label', 'View photo ' + (i + 1));
      var thumbImg = document.createElement('img'); thumbImg.src = src; thumbImg.alt = ''; thumbImg.loading = 'lazy'; t.appendChild(thumbImg);
      t.addEventListener('click', function () { setGal(i); }); th.appendChild(t);
    });
    galModels.forEach(function (item, i) {
      var slide = document.createElement('div'); slide.className = 'swiper-slide ef-pd-slide lxc-model-slide'; slide.dataset.mediaType = 'model';
      slides.appendChild(slide);
      var t = document.createElement('button'); t.type = 'button'; t.className = 'swiper-slide ef-pd-thumb lxc-thumb lxc-model-thumb';
      t.dataset.modelWidth = item.width; t.setAttribute('aria-label', 'View ' + fmtW(item.width) + ' wide 3D reference in ' + item.finish);
      t.dataset.modelLabel = t.getAttribute('aria-label');
      var img = document.createElement('img'); img.src = item.poster || state.model.img; img.alt = ''; img.loading = 'lazy'; t.appendChild(img);
      var badge = document.createElement('span'); badge.className = 'lxc-model-badge'; badge.textContent = '3D'; t.appendChild(badge);
      var label = document.createElement('span'); label.className = 'lxc-model-width'; label.textContent = fmtW(item.width) + ' wide'; t.appendChild(label);
      t.addEventListener('click', function () { setGal(galImgs.length + i); }); th.appendChild(t);
    });
    root.querySelector('#lxc-gallery-count').textContent = imgs.length + galModels.length;
    root.querySelector('#ef-pd-counter-cur').textContent = '1';
    bindModelGallery();
    if (window.EFGallery) {
      window.EFGallery.thumbs.update(); window.EFGallery.thumbs.slideTo(0, 0);
      window.EFGallery.main.update(); window.EFGallery.main.slideTo(0, 0);
      window.EFGallery.main.thumbs.update();
    }
    labelModelThumbs();
    syncModelSlide();
  }

  function flashGalHint(finish) {
    var h = root.querySelector('#lxc-galhint'); if (!h) return;
    var hasG = state.model && state.model.finishGalleries && state.model.finishGalleries[finish];
    h.innerHTML = hasG ? ('View <b>' + finish + '</b> in the gallery above.') : 'Explore the gallery above.';
    h.classList.remove('flash'); void h.offsetWidth; h.classList.add('flash');
  }
  // 3D model — resolved per STYLE (and per finish where that finish has its own model).
  // Resolution order, so the viewer stays "alive" as you move between styles:
  //   1. this style + this finish  -> exact model, no disclaimer
  //   2. this style + any finish   -> that model + a discreet "shown in X finish" note
  //   3. no model for this style   -> viewer hidden (never borrow another style's shape)
  function currentGlb(m, finish) {
    var map = m.glbFinishes; if (!map) return null;
    if (finish && map[finish]) return { url: map[finish], finish: finish, exact: true };
    var order = (m.finishes || []).concat(Object.keys(map));
    for (var i = 0; i < order.length; i++) {
      if (map[order[i]]) return { url: map[order[i]], finish: order[i], exact: false };
    }
    return null;
  }
  function usdzFor(m, finish) {
    var map = USDZMAP[m.name]; return (map && finish && map[finish]) ? map[finish] : '';
  }
  function showVisual(m, finish, width) { syncModelSlide(); }

  // ---- pricing ----
  function calc(model, w, finish) {
    var sizes = model.sizes.slice().sort(function (a, b) { return a.w - b.w; });
    var minStd = sizes[0].w, maxStd = sizes[sizes.length - 1].w, maxPrice = sizes[sizes.length - 1].price;
    var maxStdReal = sizes[sizes.length - 1].std || maxPrice; // real listing price of the largest standard
    var floor = MIN_WIDTH;
    var capMax = Math.min(120, maxStd + EXT_INCHES * MAX_COMBO_EXT);
    w = Math.max(floor, Math.min(w, capMax));
    var exact = sizes.filter(function (s) { return s.w === w; })[0];
    if (exact) return { width: w, price: finish === CF_LABEL ? exact.price : (exact.std || exact.price), pieces: 1, combo: false, custom: false, fee: 0, ext: 0, base: exact.price, std: exact.std || exact.price, maxStd: maxStd, capMax: capMax, minStd: minStd };
    if (w <= maxStd) {
      var up = sizes.filter(function (s) { return s.w >= w; })[0] || sizes[sizes.length - 1];
      return { width: w, price: up.price + CUSTOM_FEE, pieces: 1, combo: false, custom: true, fee: CUSTOM_FEE, ext: 0, base: up.price, std: up.std || up.price, baseW: up.w, maxStd: maxStd, capMax: capMax, minStd: minStd };
    }
    var numExt = Math.min(MAX_COMBO_EXT, Math.ceil((w - maxStd) / EXT_INCHES));
    return { width: w, price: nice(maxPrice * (1 + EXT_FACTOR * numExt)), pieces: 1 + numExt, combo: true, custom: true, fee: 0, ext: numExt, brackets: Math.max(2, numExt), base: maxPrice, std: maxStdReal, maxStd: maxStd, capMax: capMax, minStd: minStd };
  }

  // ---- step nav ----
  function go(n) {
    if (n !== 1) root.querySelectorAll('#lxc-grid video').forEach(function (video) { video.pause(); });
    root.querySelectorAll('.lxc__panel').forEach(function (p) { p.classList.toggle('is-active', +p.dataset.step === n); });
    root.querySelectorAll('.lxc__steps span').forEach(function (s) {
      var i = +s.dataset.step;
      s.classList.toggle('is-active', i === n);
      s.classList.toggle('is-done', i < n);
    });
    root.classList.toggle('lxc--configuring', n === 2);
    var activeHeading = root.querySelector(n === 2 ? '#lxc-m-name' : '.lxc__panel.is-active .lxc__h2');
    if (activeHeading) { activeHeading.setAttribute('tabindex', '-1'); activeHeading.focus({preventScroll:true}); }
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var stepNav = root.querySelector(n === 2 ? '.lxc__two' : '#lxc-styles');
      window.scrollTo({ top: Math.max(0, window.scrollY + stepNav.getBoundingClientRect().top - 110), behavior: 'instant' });
    }); });
    if (n === 2 && window.LXCBeam) setTimeout(function () { window.LXCBeam.resize(); }, 90);
    /* 2026-08-12: krok 2 wchodzi do historii przeglądarki — wstecz cofa do stylów, nie do poprzedniej strony */
    if (n === 2 && !lxcHist) { try { history.pushState({ lxcStep: 2 }, ''); lxcHist = true; } catch (e) {} }
  }
  var lxcHist = false;
  function lxcCurrentStep() {
    var p = root.querySelector('.lxc__panel.is-active');
    return p ? +p.dataset.step : 1;
  }
  function backToStyles() {
    if (lxcHist) { try { history.back(); return; } catch (e) {} }
    go(1);
  }
  window.addEventListener('popstate', function () {
    if (lxcCurrentStep() === 2) { lxcHist = false; go(1); }
  });
  var backTop = root.querySelector('#lxc-back-top');
  if (backTop) backTop.addEventListener('click', backToStyles);

  // ---- step 1: style grid ----
  var grid = root.querySelector('#lxc-grid');
  // Keep the demonstrated style beside the shared collection film.
  var styleNames = Object.keys(DATA);
  if (grid.querySelector('[data-efv-tile]') && styleNames.indexOf('Flat Sawn') > -1) {
    styleNames = ['Flat Sawn'].concat(styleNames.filter(function (name) { return name !== 'Flat Sawn'; }));
  }
  styleNames.forEach(function (name) {
    var m = DATA[name]; m.name = name;
    // official per-finish galleries (real photos, 1:1) override the placeholder gallery
    if (FG[name]) {
      m.finishGalleries = FG[name];
      var _def = (m.finishes || []).filter(function (f) { return FG[name][f]; })[0] || Object.keys(FG[name])[0];
      var _g = FG[name][_def];
      if (_g && _g.length) { m.gallery = _g; m.img = _g[0]; }
    }
    // per-finish 3D models (generated + real) — 3D shows for every model/finish that has one
    if (GLBMAP[name]) {
      m.glbFinishes = Object.assign({}, m.glbFinishes || {}, GLBMAP[name]);
      if (!m.glb) m.glb = m.glbFinishes[(m.finishes || [])[0]] || m.glbFinishes[Object.keys(m.glbFinishes)[0]];
    }
    var lo = Math.min.apply(null, m.sizes.map(function (s) { return s.std || s.price; }));
    var b = document.createElement('div');
    b.className = 'lxc-card'; b.setAttribute('role', 'button'); b.tabIndex = 0; b.setAttribute('aria-pressed', 'false');
    b.addEventListener('keydown', function (e) { if (e.target === b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); selectModel(name, b); } });
    b.innerHTML = '<div class="lxc-card__imgwrap"><img alt="' + name + ' non-combustible mantel" loading="lazy"></div>' +
      '<div class="lxc-card__b"><strong>' + name + '</strong><span class="lxc-card__description">' + (m.desc || '') + '</span><span class="lxc-card__dimensions">Depth ' + m.depth + ' &middot; Height ' + m.height + '</span><span class="lxc-card__from">From ' + money(lo) + '</span><span class="lxc-card__choose">Choose ' + name + ' &rarr;</span>' +
      '<div class="lxc-card__sw" role="group" aria-label="Preview colors"></div></div>';
    var cimg = b.querySelector('img'); cimg.src = m.img;
    var sw = b.querySelector('.lxc-card__sw');
    m.finishes.forEach(function (f) {
      var dot = document.createElement('button'); dot.type = 'button'; dot.className = 'lxc-card__dot'; dot.title = f; dot.setAttribute('aria-label', f);
      if (SWATCH[f]) dot.style.backgroundImage = 'url(' + SWATCH[f] + ')'; else dot.classList.add('lxc-card__noimg');
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var g = (m.finishGalleries && m.finishGalleries[f] && m.finishGalleries[f][0]) || SWATCH[f] || m.img;
        cimg.src = g; m._previewFinish = f;
        sw.querySelectorAll('.lxc-card__dot').forEach(function (d) { d.classList.remove('on'); }); dot.classList.add('on');
      });
      sw.appendChild(dot);
    });
    b.addEventListener('click', function () { selectModel(name, b); });
    grid.appendChild(b);
  });

  // Clickable step chips — jump back to any reached step
  root.querySelectorAll('.lxc__steps span').forEach(function (s) {
    s.setAttribute('role', 'button'); s.tabIndex = 0;
    var jump = function () { var n = +s.dataset.step; if (n === 1) return go(1); if (!state.model) return; go(n); };
    s.addEventListener('click', jump);
    s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); jump(); } });
  });

  // Deep-link 2026-08-14: ?style=Flat+Sawn (z listingow standard) -> auto krok 2 z tym stylem
  try {
    var qsp = new URLSearchParams(location.search);
    var qsStyle = (qsp.get('style') || '').trim().toLowerCase();
    if (qsStyle) {
      var qsHit = Object.keys(DATA).find(function (k) { return k.toLowerCase() === qsStyle; });
      if (qsHit) setTimeout(function () {
        var qsCard = Array.prototype.find.call(grid.querySelectorAll('.lxc-card'), function (c) {
          var st = c.querySelector('strong'); return st && st.textContent.trim() === qsHit;
        });
        selectModel(qsHit, qsCard || null);
        var qsFin = (qsp.get('finish') || '').trim().toLowerCase();
        if (qsFin) {
          var fb = Array.prototype.find.call(root.querySelectorAll('#lxc-finish button[data-finish]'), function (button) { return button.dataset.finish.toLowerCase() === qsFin; });
          if (fb) { fb.closest('button').click(); state.finishChosen = false; root.querySelectorAll('#lxc-finish button').forEach(function (b) { b.classList.remove('is-active'); }); render2(); }
        }
        var qsWidth = Number(qsp.get('width')); if (qsWidth > 0) setWidth(qsWidth);
        var qsBracket = qsp.get('bracket');
        if (validBracket(qsBracket)) { state.bracketColor = qsBracket; render2(); }
      }, 60);
    }
  } catch (e) {}

  function selectModel(name, btn) {
    state.model = DATA[name];
    state.finishChosen = false;
    state.finish = state.model._previewFinish || (state.model.finishes.indexOf(state.finish) >= 0 ? state.finish : state.model.finishes[0]);
    grid.querySelectorAll('.lxc-card').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    if (btn) btn.setAttribute('aria-pressed', 'true');
    buildStep2();
    go(2);
  }

  // ---- step 2: width ----
  function buildStep2() {
    var m = state.model;
    var sizes = m.sizes.slice().sort(function (a, b) { return a.w - b.w; });
    var minStd = MIN_WIDTH, maxStd = sizes[sizes.length - 1].w, capMax = Math.min(120, maxStd + 48);
    state.width = maxStd; // default to largest standard

    root.querySelector('#lxc-m-name').textContent = m.name + ' Non-Combustible Mantel';
    root.querySelector('#lxc-m-depth').textContent = m.depth;
    root.querySelector('#lxc-m-height').textContent = m.height;
    var dEl = root.querySelector('#lxc-m-desc'); if (dEl) dEl.textContent = m.desc || '';
    // gallery (white-bg; swaps per finish if finish-specific images exist)
    renderGallery(galleryFor(m, state.finish));

    // standard quick-picks
    var std = root.querySelector('#lxc-std'); std.innerHTML = '';
    sizes.forEach(function (s) {
      var bt = document.createElement('button'); bt.type = 'button';
      var widthLabel = document.createElement('span'); widthLabel.textContent = s.w + '"';
      var priceLabel = document.createElement('span'); priceLabel.className = 'lxc__size-delta';
      bt.appendChild(widthLabel); bt.appendChild(priceLabel);
      bt.dataset.w = s.w; bt.addEventListener('click', function () { setWidth(s.w); });
      std.appendChild(bt);
    });

    // finishes
    var fin = root.querySelector('#lxc-finish'); fin.innerHTML = '';
    m.finishes.forEach(function (f) {
      var bt = document.createElement('button'); bt.type = 'button'; bt.dataset.finish = f;
      bt.innerHTML = (SWATCH[f] ? '<img src="' + SWATCH[f] + '" alt="" loading="lazy">' : '') + '<span>' + f + '</span>';
      bt.addEventListener('click', function () {
        state.finish = f; state.finishChosen = true; fin.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); }); bt.classList.add('is-active'); toggleColorRef(false); render2();
        renderGallery(galleryFor(m, f));
        showVisual(m, f, state.width);
        flashGalHint(f);
      });
      if (state.finishChosen && f === state.finish) bt.classList.add('is-active');
      fin.appendChild(bt);
    });
    // Custom Color Match (+CUSTOM_FINISH_FEE) — match any color from a paint chip, sample or photo
    var cf = document.createElement('button'); cf.type = 'button'; cf.className = 'lxc-cf'; cf.dataset.finish = CF_LABEL;
    cf.innerHTML = '<img class="lxc-cf-photo" src="' + VISUAL_ASSETS.customColor + '" alt="Manufacturer custom color examples" loading="lazy"><span class="lxc-cf__copy"><strong>Custom Color Match</strong><span>Your photo or physical sample</span></span><b>+$' + CUSTOM_FINISH_FEE + '</b>';
    cf.addEventListener('click', function () {
      state.finish = CF_LABEL; state.finishChosen = true; fin.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); }); cf.classList.add('is-active'); toggleColorRef(true); render2();
    });
    fin.appendChild(cf);
    toggleColorRef(false);

    var range = root.querySelector('#lxc-range');
    range.min = minStd; range.max = capMax; range.step = 0.5; range.value = maxStd;
    range.oninput = function () { setWidth(parseFloat(range.value)); };
    var num = root.querySelector('#lxc-num');
    num.min = minStd; num.max = capMax; num.step = 0.5; num.value = maxStd;
    num.onchange = function () { setWidth(parseFloat(num.value) || maxStd); };

    setWidth(maxStd);
  }

  function setWidth(w) {
    var c = calc(state.model, w, state.finish);
    state.width = c.width;
    var rng = root.querySelector('#lxc-range');
    rng.value = c.width;
    // purely visual: expose the filled fraction so CSS can paint the track up to the thumb
    var rmn = parseFloat(rng.min), rmx = parseFloat(rng.max);
    if (rmx > rmn) rng.style.setProperty('--lxc-fill', (((c.width - rmn) / (rmx - rmn)) * 100).toFixed(1) + '%');
    root.querySelector('#lxc-num').value = c.width;
    root.querySelectorAll('#lxc-std button').forEach(function (b) { b.classList.toggle('is-active', +b.dataset.w === c.width); });
    render2();
    showVisual(state.model, state.finish, c.width);
  }

  // Display-only width comparison; calc remains the sole price authority.
  function widthPriceComparison(model, width, finish) {
    var baseWidth = Math.min.apply(null, model.sizes.map(function (size) { return size.w; }));
    var basePrice = calc(model, baseWidth, finish).price;
    var finishFee = finish === CF_LABEL ? CUSTOM_FINISH_FEE : 0;
    var price = calc(model, width, finish).price;
    return { baseWidth: baseWidth, baseTotal: basePrice + finishFee, delta: price - basePrice, total: price + finishFee };
  }
  function widthDeltaText(delta) { return delta === 0 ? 'Base price' : (delta < 0 ? '−' : '+') + money(Math.abs(delta)); }
  function renderWidthPrices(c) {
    var std = root.querySelector('#lxc-std'), comparison = widthPriceComparison(state.model, c.width, state.finish);
    var basis = root.querySelector('#lxc-width-base');
    if (!basis) {
      basis = std.previousElementSibling;
      if (!basis || !basis.classList.contains('ef-concrete-helper')) { basis = document.createElement('p'); basis.className = 'ef-concrete-helper'; std.before(basis); }
      basis.id = 'lxc-width-base';
    }
    basis.textContent = 'Width differences from ' + fmtW(comparison.baseWidth) + ' ' + state.model.name + ' at ' + money(comparison.baseTotal) + '. ' + (state.finish === CF_LABEL ? 'Includes Custom Color Match; same depth and height.' : 'Same standard finish, depth and height.');
    std.querySelectorAll('button').forEach(function (button) {
      var option = widthPriceComparison(state.model, Number(button.dataset.w), state.finish), priceLabel = button.querySelector('.lxc__size-delta');
      if (priceLabel) priceLabel.textContent = widthDeltaText(option.delta);
      button.setAttribute('aria-label', fmtW(Number(button.dataset.w)) + ' wide, ' + (option.delta === 0 ? 'base price' : money(Math.abs(option.delta)) + (option.delta < 0 ? ' less' : ' more') + ' than ' + fmtW(option.baseWidth)) + ', ' + money(option.total) + ' mantel price');
      button.setAttribute('aria-describedby', 'lxc-width-base');
    });
    var current = root.querySelector('#lxc-width-price');
    if (!current) {
      current = document.createElement('p'); current.id = 'lxc-width-price'; current.className = 'lxc__width-price';
      root.querySelector('.lxc__width').after(current);
      ['#lxc-range', '#lxc-num'].forEach(function (selector) { var input = root.querySelector(selector), ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean); ['lxc-width-base', 'lxc-width-price'].forEach(function (id) { if (ids.indexOf(id) < 0) ids.push(id); }); input.setAttribute('aria-describedby', ids.join(' ')); });
    }
    current.textContent = fmtW(c.width) + ' width: ' + widthDeltaText(comparison.delta) + (comparison.delta === 0 ? '' : ' vs ' + fmtW(comparison.baseWidth)) + ' · ' + money(comparison.total) + ' mantel price';
  }

  function render2() {
    var c = calc(state.model, state.width, state.finish);
    renderWidthPrices(c);
    // combo banner
    var ban = root.querySelector('#lxc-banner');
    if (c.combo) {
      ban.classList.add('is-on');
      var bset = 'decorative bracket trim';
      var bhow = '. Extension availability varies by style; contact us to confirm the layout for your mantel.';
      var preview = BRACKET_MODELS[state.model.name];
      var caption = preview ? 'Illustration: ' + state.model.name + ' in ' + preview.finish + ' with Matte Black decorative brackets. Top: illustrative concrete rear. Bottom: finished front. Two-section example; dimensions and bracket positions depend on your confirmed layout.' : '';
      ban.innerHTML = '<b>A longer mantel with decorative bracket trim</b>' +
        'Your ' + fmtW(c.width) + ' layout combines ' + c.pieces + ' sections with ' + bset + bhow;
      if (preview && preview.src) {
        ban.innerHTML += '<a class="lxc__combodiag" role="button" aria-haspopup="dialog" aria-label="Enlarge ' + previewText(state.model.name) + ' bracket preview" data-preview-caption="' + previewText(caption) + '" href="' + previewText(preview.src) + '" target="_blank" rel="noopener"><span class="lxc-diagram-loupe" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M10 7v6M7 10h6"/></svg></span><img src="' + previewText(preview.src) + '" alt="' + previewText(state.model.name + ' in ' + preview.finish + ' with Matte Black brackets, rear sections above and assembled front below — illustration') + '" width="' + preview.width + '" height="' + preview.height + '" loading="lazy"><span>See brackets on ' + previewText(state.model.name) + ' · tap to enlarge</span></a><p class="lxc__hint">' + previewText(caption) + '</p>';
      }
    } else if (c.custom) {
      ban.classList.add('is-on');
      ban.innerHTML = '<b>Custom width &mdash; cut &amp; finished to ' + fmtW(c.width) + '</b>Hand-trimmed from our ' + c.baseW + '" mantel to your selected finished width. +' + money(c.fee) + ' custom fee.';
    } else { ban.classList.remove('is-on'); ban.innerHTML = ''; }

    var bracketWrap = root.querySelector('#lxc-brackets');
    if (bracketWrap) {
      bracketWrap.hidden = !c.combo;
      bracketWrap.querySelectorAll('[data-bracket-color]').forEach(function (button) {
        var chosen = button.dataset.bracketColor === state.bracketColor;
        button.classList.toggle('is-active', chosen); button.setAttribute('aria-pressed', String(chosen));
      });
    }
    root.dataset.bracketColor = c.combo && validBracket(state.bracketColor) ? state.bracketColor : '';
    // price + breakdown
    root.dataset.finishChosen = String(state.finishChosen);
    root.dataset.model = state.model.name; root.dataset.width = String(state.width); root.dataset.finish = state.finishChosen ? state.finish : '';
    var ff = (state.finish === CF_LABEL) ? CUSTOM_FINISH_FEE : 0;
    root.querySelector('#lxc-amt').textContent = money(c.price + ff);
    var orderSummary = root.querySelector('#lxc-order-summary'); if (orderSummary) orderSummary.textContent = state.model.name + ' · ' + fmtW(c.width) + ' wide · ' + (state.finishChosen ? state.finish : 'Choose a finish') + (c.combo ? ' · ' + (validBracket(state.bracketColor) ? state.bracketColor + ' decorative brackets' : 'Choose a bracket finish') : '');
    root.querySelectorAll('#lxc-finish button').forEach(function (b) { b.setAttribute('aria-pressed', b.classList.contains('is-active') ? 'true' : 'false'); });
    root.querySelectorAll('#lxc-std button').forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.w === c.width ? 'true' : 'false'); });
    var bd = root.querySelector('#lxc-breakdown'); bd.innerHTML = '';
    var rows = [];
    if (c.combo) {
      rows.push(['Base ' + c.maxStd + '" mantel', money(c.base)]);
      rows.push([c.ext + ' &times; extension (65% each)', money(c.price - c.base)]);
      rows.push(['Decorative bracket trim' + (validBracket(state.bracketColor) ? ' — ' + state.bracketColor : ''), 'included']);
    } else if (c.custom) {
      rows.push(['Base ' + c.baseW + '" mantel', money(c.base)]);
      rows.push(['Custom width fee', '+' + money(c.fee)]);
    } else {
      rows.push(['Base price', money(c.price)]);
    }
    if (ff) rows.push(['Custom color match', '+' + money(ff)]);
    rows.forEach(function (r) { bd.innerHTML += '<div><span>' + r[0] + '</span><span>' + r[1] + '</span></div>'; });
    updateBuy();
  }

  root.querySelectorAll('[data-bracket-color]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!state.model || !calc(state.model, state.width, state.finish).combo || !validBracket(button.dataset.bracketColor)) return;
      state.bracketColor = button.dataset.bracketColor; lxcErr(null); render2();
    });
  });
  root.querySelector('#lxc-back1').addEventListener('click', backToStyles);

  // ---- step 2: buy actions — EVERYTHING adds to the cart (base variant + made-to-order surcharge) ----
  // base variant = real product variant at the relevant standard width (custom width cuts from baseW; combo from maxStd).
  // For Custom Color Match or finishes without their own variant, any finish's variant at that width is used and the
  // real finish/size/title are shown in cart via line-item properties (_title / Finish / Width / _swatch_url).
  function baseVariantFor(m, finish, c) {
    var map = VARIANTS[m.name]; if (!map) return null;
    var bw = String(c.combo ? c.maxStd : (c.custom ? c.baseW : c.width));
    if (finish !== CF_LABEL && map[finish] && map[finish][bw]) return { id: map[finish][bw], finishKey: finish };
    // A standard order must never use a different finish as its native variant.
    if (!c.custom && !c.combo && finish !== CF_LABEL) return null;
    var fins = Object.keys(map);
    for (var i = 0; i < fins.length; i++) { if (map[fins[i]][bw]) return { id: map[fins[i]][bw], finishKey: fins[i] }; }
    return null;
  }
  function buyState() {
    var m = state.model, c = calc(m, state.width, state.finish), ff = (state.finish === CF_LABEL) ? CUSTOM_FINISH_FEE : 0, total = c.price + ff;
    var isCustom = c.custom || c.combo || state.finish === CF_LABEL;
    // basePrice = REAL listing price of the base variant (sizes[].std), not the +15% builder price -> surcharge > 0 routes to the worker
    var basePrice = c.std || ((c.combo || c.custom) ? c.base : c.price);
    var base = baseVariantFor(m, state.finish, c);
    var surcharge = Math.max(0, Math.round(total - basePrice));
    return { c: c, ff: ff, total: total, isCustom: isCustom, base: base, basePrice: basePrice, surcharge: surcharge };
  }
  var purchasePending = false;
  function updateBuy() {
    var buy = root.querySelector('#lxc-buy'); if (!buy || !state.model) return;
    root.querySelector('#lxc-add').setAttribute('aria-busy', String(purchasePending));
    if (purchasePending) { root.querySelector('#lxc-add').disabled = true; root.querySelector('#lxc-express').disabled = true; return; }
    var b = buyState(), add = root.querySelector('#lxc-add'), exp = root.querySelector('#lxc-express'),
        cn = root.querySelector('#lxc-custnote'), qty = root.querySelector('#lxc-qty');
    add.disabled = !state.finishChosen || (b.c.combo && !validBracket(state.bracketColor)); exp.disabled = add.disabled;
    if (!state.finishChosen) { add.textContent = 'Choose your finish'; exp.style.display = 'none'; if (cn) cn.style.display = 'none'; return; }
    if (b.c.combo && !validBracket(state.bracketColor)) { add.textContent = 'Choose your bracket finish'; exp.style.display = 'none'; if (cn) cn.style.display = 'none'; return; }
    if (b.base && !b.isCustom && b.surcharge === 0) {
      buy.dataset.mode = 'native';
      add.innerHTML = 'Add to Cart &mdash; ' + money(b.total);
      exp.style.display = ''; if (cn) cn.style.display = 'none';
      // made-to-order custom items are 1-off — hide qty (keeps the base+surcharge math clean)
      if (qty) qty.style.display = b.isCustom ? 'none' : '';
      if (b.isCustom) { var qn = root.querySelector('#lxc-qnum'); if (qn) qn.value = 1; }
    } else {
      buy.dataset.mode = 'worker';
      add.innerHTML = 'Buy Now &mdash; ' + money(b.total);
      exp.style.display = 'none'; if (cn) cn.style.display = ''; if (qty) qty.style.display = b.isCustom ? 'none' : '';
      if (b.isCustom) { var fallbackQty = root.querySelector('#lxc-qnum'); if (fallbackQty) fallbackQty.value = 1; }
    }
  }
  function lxcQty() { return Math.max(1, parseInt((root.querySelector('#lxc-qnum') || {}).value, 10) || 1); }
  function lxcErr(msg) { var e = root.querySelector('#lxc-err'); if (!e) return; if (msg) { e.textContent = msg; e.style.display = 'block'; } else { e.style.display = 'none'; } }
  function buildProps(c, ff) {
    var m = state.model, p = {
      'Model': m.name + ' Non-Combustible Mantel',
      'Finish': ff ? (CF_LABEL + ' (+$' + CUSTOM_FINISH_FEE + ')') : state.finish,
      'Width': fmtW(c.width), 'Depth': m.depth, 'Height': m.height,
      'Construction': c.pieces === 1 ? 'Single piece' : (c.pieces + '-piece joined with decorative bracket trim')
    };
    if (c.combo && validBracket(state.bracketColor)) p['Decorative bracket finish'] = state.bracketColor;
    var cref = ((root.querySelector('#lxc-colorref') || {}).value || '').trim();
    if (ff && cref) p['Color reference'] = cref;
    if (ff) p['Color reference method'] = root.querySelector('input[name="lxc-color-method"]:checked')?.value === 'sample' ? 'Physical sample' : 'Reference photo';
    var note = ((root.querySelector('#lxc-notes') || {}).value || '').trim();
    if (note) p['Notes'] = note;
    return p;
  }
  // native add-to-cart — base variant (real price) + made-to-order surcharge ($1 × $diff), grouped in cart
  function addNative(goCheckout) {
    if (purchasePending) return;
    if (!state.model || !state.finishChosen) { lxcErr('Choose a finish before adding your mantel.'); return; }
    if (calc(state.model, state.width, state.finish).combo && !validBracket(state.bracketColor)) { lxcErr('Choose Black or Bronze decorative bracket trim before adding your mantel.'); return; }
    var b = buyState(); if (!b.base) return workerCheckout();
    /* 2026-08-13 (Daniel: "kosmiczne ilosci sztuk"): kazda DOPLATA idzie przez Draft Order
       Worker (1 linia, prawdziwa cena, qty 1) zamiast do koszyka jako $1 x kwota. */
    if (b.isCustom || b.surcharge > 0) return workerCheckout();
    var m = state.model, c = b.c, qn = b.isCustom ? 1 : lxcQty();
    var btn = goCheckout ? root.querySelector('#lxc-express') : root.querySelector('#lxc-add'), label = btn.innerHTML;
    purchasePending = true; updateBuy(); btn.textContent = goCheckout ? 'Going to checkout…' : 'Adding…'; lxcErr(null);
    var cfg = 'lxc-' + Date.now();
    var bp = buildProps(c, b.ff);
    bp['_title'] = m.name + ' Non-Combustible Mantel';
    bp['_config_id'] = cfg; bp['_lxc'] = '1';
    if (state.finish !== CF_LABEL && SWATCH[state.finish]) bp['_swatch_url'] = SWATCH[state.finish];
    var items = [{ id: Number(b.base.id), quantity: qn, properties: bp }];
    if (b.surcharge > 0) {
      var parentTitle = (PTITLES[m.name] && PTITLES[m.name][b.base.finishKey]) || '';
      var optType = c.combo ? ('Made-to-order — ' + c.pieces + '-piece, ' + fmtW(c.width))
                  : c.custom ? ('Made-to-order — custom ' + fmtW(c.width))
                  : 'Custom color match';
      items.push({ id: SURCHARGE_VARIANT, quantity: b.surcharge, properties: {
        '_parent_product': parentTitle, '_config_id': cfg, '_option_type': optType, '_amount_only': '1', '_lxc': '1'
      } });
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error((d && d.description) || ('cart ' + r.status)); }); return r.json(); })
      .then(function () {
        if (goCheckout) { (window.top || window).location.href = '/checkout'; return; }
        purchasePending = false; updateBuy();
        if (window.EFCartDrawer && window.EFCartDrawer.open) window.EFCartDrawer.open();
        else window.location.href = '/cart';
      })
      .catch(function () { purchasePending = false; updateBuy(); lxcErr('Could not add to cart. Please try again or call (949) 619-7824.'); });
  }
  // worker checkout (custom price) — custom width / combo / Custom Color Match
  function workerCheckout() {
    if (purchasePending) return;
    if (!state.model || !state.finishChosen) { lxcErr('Choose a finish before adding your mantel.'); return; }
    if (calc(state.model, state.width, state.finish).combo && !validBracket(state.bracketColor)) { lxcErr('Choose Black or Bronze decorative bracket trim before adding your mantel.'); return; }
    var btn = root.querySelector('#lxc-add'), label = btn.innerHTML;
    var m = state.model, c = calc(m, state.width, state.finish), ff = (state.finish === CF_LABEL) ? CUSTOM_FINISH_FEE : 0, total = c.price + ff;
    lxcErr(null); purchasePending = true; updateBuy(); btn.textContent = 'Creating your order…';
    var P = buildProps(c, ff); P['_config_id'] = 'lxc-' + Date.now();
    var note = ((root.querySelector('#lxc-notes') || {}).value || '').trim();
    var payload = {
      configuration: {version: 'ef-checkout-20260912-v1', family: 'lexington', catalog: 'draft', modelKey: m.name, widthInches: state.width, finish: state.finish, bracketColor: state.bracketColor || null},
      product_title: 'Custom ' + m.name + ' Mantel — ' + fmtW(c.width) + ' ' + state.finish,
      variant_id: m.variantId, quantity: (c.custom || c.combo || ff) ? 1 : lxcQty(), calculated_price: Math.round(total * 100), properties: P,
      customer_note: 'Lexington custom mantel — ' + Object.keys(P).map(function (k) { return k + ': ' + P[k]; }).join(' | ') + (note ? (' || Notes: ' + note) : '')
    };
    var inIframe = (window.top !== window.self);
    async function doSend() {
      try { await window.EFPrepareCheckout(payload); } catch (_) { purchasePending = false; updateBuy(); lxcErr('Could not prepare checkout. Please reload the page and try again.'); return; }
      fetch(WORKER, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }); })
        .then(function (res) {
          if (res.ok && res.d && res.d.invoice_url) {
            if (inIframe) { window.open(res.d.invoice_url, '_blank'); purchasePending = false; updateBuy(); }
            else { window.location.href = res.d.invoice_url; }
            return;
          }
          throw new Error(res.d && res.d.message || 'Could not create your order. Please call (949) 619-7824 or try again.');
        })
        .catch(function (error) { purchasePending = false; updateBuy(); lxcErr(error.message); });
    }
    var photoInput = root.querySelector('#lxc-photo');
    var usePhoto = root.querySelector('input[name="lxc-color-method"]:checked')?.value !== 'sample';
    var file = (ff && usePhoto && photoInput && photoInput.files && photoInput.files[0]) ? photoInput.files[0] : null;
    if (file && (file.size > 10 * 1024 * 1024 || (file.type && file.type.indexOf('image/') !== 0))) { purchasePending = false; updateBuy(); lxcErr('Choose an image under 10 MB so we can include your color reference.'); return; }
    if (file && file.size <= 10 * 1024 * 1024) {
      var reader = new FileReader();
      reader.onload = function () { payload.color_photo = reader.result; payload.color_photo_name = file.name; doSend(); };
      reader.onerror = function () { purchasePending = false; updateBuy(); lxcErr('We couldn’t read your color photo. Please choose it again before placing your order.'); };
      reader.readAsDataURL(file);
    } else { doSend(); }
  }
  root.querySelector('#lxc-add').addEventListener('click', function () {
    if (root.querySelector('#lxc-buy').dataset.mode === 'native') addNative(false); else workerCheckout();
  });
  root.querySelector('#lxc-express').addEventListener('click', function () { addNative(true); });
  (function () {
    var minus = root.querySelector('#lxc-qminus'), plus = root.querySelector('#lxc-qplus'), n = root.querySelector('#lxc-qnum');
    function set(v) { if (n) n.value = Math.max(1, v); }
    if (minus) minus.addEventListener('click', function () { set(lxcQty() - 1); });
    if (plus) plus.addEventListener('click', function () { set(lxcQty() + 1); });
  })();

  // upload label feedback
  (function () {
    var pi = root.querySelector('#lxc-photo'), tx = root.querySelector('#lxc-upload-text');
    if (pi && tx) pi.addEventListener('change', function () {
      tx.textContent = (pi.files && pi.files[0]) ? ('✓ ' + pi.files[0].name + ' attached') : 'Choose a color reference photo';
    });
  })();

  // scrollbar width -> --ef-sbw so the full-bleed bands don't trigger horizontal scroll
  (function () {
    function setSbw() {
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--ef-sbw', (sbw > 0 ? sbw : 0) + 'px');
    }
    setSbw();
    window.addEventListener('resize', setSbw, { passive: true });
  })();

  // scroll-reveal + animated counters for the premium info section
  (function () {
    function animateCounts(scope) {
      var nodes = scope.querySelectorAll('[data-count]');
      for (var i = 0; i < nodes.length; i++) {
        (function (el) {
          if (el._counted) return; el._counted = true;
          var to = parseFloat(el.getAttribute('data-count')) || 0;
          var suf = el.getAttribute('data-suffix') || '';
          var dur = 1200, start = null;
          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
            el.textContent = Math.round(to * eased) + suf;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        })(nodes[i]);
      }
    }
    var els = document.querySelectorAll('.lxc-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); animateCounts(el); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); animateCounts(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  })();

  // install-video facade -> load YouTube on click
  (function () {
    var vf = document.getElementById('lxc-vfacade'); if (!vf) return;
    vf.addEventListener('click', function () {
      var id = vf.getAttribute('data-yt');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = 'Mantel installation video';
      f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      f.setAttribute('allowfullscreen', '');
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
      vf.parentNode.replaceChild(f, vf);
    });
  })();
})();

/* ===== EF UX layer — 2026-08-07 (agent) =====================================
   Adds on top of the configurator WITHOUT touching its logic/handlers:
   1) crossfade (~250ms) of the main gallery image when a finish (or thumb) swaps it
      + capture-phase preload of the finish's first photo before the swap paints
   2) "Save my design" -> localStorage 'ef-saved-projects' ({title,url,date},
      format read by /pages/saved · sections/efn-saved.liquid) + toast
   3) "Most ordered" badge on the best-selling finish (data-bestseller-finish,
      source: collection concrete-mantel-shelves BEST_SELLING, 2026-08-07)
   ========================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('lxc-root');
  if (!root) return;
  var FG2 = {}; try { FG2 = JSON.parse(document.getElementById('ef-lxc-fg').textContent); } catch (e) {}

  function modelName() {
    var el = root.querySelector('#lxc-m-name');
    return el ? el.textContent.replace(/\s*Non-Combustible Mantel\s*$/, '').trim() : '';
  }

  // preload the finish's first photo before the configurator swaps the gallery
  root.addEventListener('pointerdown', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    var fin = null, model = null;
    var chip = t.closest('#lxc-finish button');
    if (chip && !chip.classList.contains('lxc-cf')) {
      var sp = chip.querySelector('span'); fin = chip.dataset.finish || (sp ? sp.textContent.trim() : null); model = modelName();
    } else {
      var dot = t.closest('.lxc-card__dot');
      if (dot) {
        fin = dot.getAttribute('aria-label') || dot.title;
        var card = dot.closest('.lxc-card'), st = card && card.querySelector('strong');
        model = st ? st.textContent.trim() : null;
      }
    }
    if (fin && model && FG2[model] && FG2[model][fin] && FG2[model][fin][0]) {
      var im = new Image(); im.src = FG2[model][fin][0];
    }
  }, true);

  /* ---- 2) Save my design ---- */
  var saveBtn = root.querySelector('#lxc-save'), toast = document.getElementById('lxc-toast'), toastTimer = null;
  function showToast() {
    if (!toast) return;
    toast.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { toast.classList.add('is-on'); }); });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 5000);
  }
  if (saveBtn) saveBtn.addEventListener('click', function () {
    try {
      var finBtn = root.querySelector('#lxc-finish button.is-active');
      var finish = finBtn ? (finBtn.dataset.finish || (finBtn.classList.contains('lxc-cf') ? 'Custom Color Match' : (finBtn.querySelector('span') ? finBtn.querySelector('span').textContent.trim() : ''))) : '';
      var width = (root.querySelector('#lxc-num') || {}).value || '';
      var title = (root.dataset.model || 'Custom Concrete') + ' Mantel — ' + (finish || 'your finish') + ' · ' + width + '"' + (root.dataset.bracketColor ? ' · ' + root.dataset.bracketColor + ' brackets' : '');
      // Save explicit selections; photo files remain local and must be selected again.
      var entry = { title: title, url: (function () { var u = new URL(window.location.href); u.searchParams.set('style', root.dataset.model); u.searchParams.set('width', width); if (finish) u.searchParams.set('finish', finish); else u.searchParams.delete('finish'); if (root.dataset.bracketColor) u.searchParams.set('bracket', root.dataset.bracketColor); else u.searchParams.delete('bracket'); return u.href; })(), date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) };
      var arr = [];
      try { arr = JSON.parse(localStorage.getItem('ef-saved-projects') || '[]'); } catch (e) { arr = []; }
      if (!Array.isArray(arr)) arr = [];
      arr = arr.filter(function (p) { return !(p && p.title === entry.title && p.url === entry.url); });
      arr.unshift(entry);
      if (arr.length > 50) arr.length = 50;
      localStorage.setItem('ef-saved-projects', JSON.stringify(arr));
      saveBtn.classList.add('is-saved');
      var lbl = saveBtn.querySelector('span'); if (lbl) lbl.textContent = 'Saved to your projects';
      setTimeout(function () { saveBtn.classList.remove('is-saved'); if (lbl) lbl.textContent = 'Save my design'; }, 4000);
      showToast();
    } catch (e) { /* storage blocked (private mode) — fail silently */ }
  });

  /* ---- 3) "Most ordered" badge on the best-selling finish ---- */
  var BEST = root.getAttribute('data-bestseller-finish');
  var finWrap = root.querySelector('#lxc-finish');
  function decorate() {
    if (!BEST || !finWrap) return;
    var btns = finWrap.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.classList.contains('lxc-cf') || b.querySelector('.lxc-mostordered')) continue;
      var sp = b.querySelector('span');
      if ((b.dataset.finish || (sp && sp.textContent.trim())) === BEST) {
        var badge = document.createElement('span');
        badge.className = 'lxc-mostordered'; badge.textContent = 'Pale Honey'; badge.hidden = true;
        b.appendChild(badge);
      }
    }
  }
  if (finWrap && 'MutationObserver' in window) {
    new MutationObserver(function () { decorate(); }).observe(finWrap, { childList: true });
  }
  decorate();
})();

/* 2026-08-07 (agent): the width-to-scale "8-ft wall" SVG illustration was removed
   (markup #lxc-scalewall + its CSS + this redraw block). It read as a diagram, not
   as premium product imagery — the live 3D model now carries the scale story. */

/* Inline Lexington samples; preserve selections if Shopify rejects an item. */
(function(){
 var form=document.getElementById('lxc-samples');
 if(form&&!form.dataset.bound){form.dataset.bound='true';var submit=form.querySelector('[type="submit"]'),status=form.querySelector('[data-sample-status]'),total=form.querySelector('[data-sample-total]'),busy=false;
 function selected(){return Array.from(form.querySelectorAll('input:checked'));}
 function refresh(){var items=selected(),cents=items.reduce(function(n,i){return n+Number(i.dataset.price);},0);total.textContent='Total $'+(cents/100);submit.disabled=busy||!items.length;}
 form.addEventListener('change',function(){status.textContent='';refresh();});
 form.addEventListener('submit',async function(e){e.preventDefault();if(busy||!selected().length)return;var inputs=selected(),items=inputs.map(function(i){return{id:Number(i.value),quantity:1,properties:{'_sample':'Color sample board','Color':i.dataset.name}};});busy=true;refresh();submit.textContent='Adding…';status.textContent='';
 try{var response=await fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});var data=await response.json();if(!response.ok||data.status>=400)throw new Error('cart');inputs.forEach(function(i){i.checked=false;});status.textContent='Your samples have been added to the cart.';if(window.EFCartDrawer&&window.EFCartDrawer.open)window.EFCartDrawer.open();else window.location.href='/cart';}
 catch(error){status.textContent='We couldn’t add your samples. Your selections are saved here — please try again.';}
 finally{busy=false;submit.textContent='Add samples to cart';refresh();}});refresh();}

})();

/* Assembly diagram zoom: delegated because width/finish changes redraw the banner. */
(function(){
 var root=document.getElementById('lxc-root');if(!root||document.getElementById('lxcDiagramZoom'))return;
 var dialog=document.createElement('dialog');dialog.id='lxcDiagramZoom';dialog.className='lxc-diagram-zoom';dialog.setAttribute('aria-labelledby','lxcDiagramZoomTitle');
 dialog.innerHTML='<div class="lxc-diagram-zoom__head"><h2 id="lxcDiagramZoomTitle">Decorative brackets on your mantel</h2><button type="button" data-diagram-close aria-label="Close enlarged illustration">×</button></div><div class="lxc-diagram-zoom__media" tabindex="0" aria-label="Mantel illustration — scroll to explore when enlarged"><img alt="Mantel with Matte Black decorative brackets"></div><div class="lxc-diagram-zoom__foot"><button type="button" data-diagram-toggle aria-pressed="false">Zoom in</button><p data-diagram-hint>Matte Black decorative brackets shown.</p></div>';
 document.body.appendChild(dialog);var opener=null,caption='',savedOverflow='',media=dialog.querySelector('.lxc-diagram-zoom__media'),image=media.querySelector('img'),toggle=dialog.querySelector('[data-diagram-toggle]'),hint=dialog.querySelector('[data-diagram-hint]');
 function reset(){dialog.classList.remove('is-enlarged');toggle.setAttribute('aria-pressed','false');toggle.textContent='Zoom in';hint.textContent=caption;media.scrollTop=0;media.scrollLeft=0;}
 function open(link){if(typeof dialog.showModal!=='function')return false;opener=link;caption=link.dataset.previewCaption || 'Matte Black decorative brackets shown. Final layout may differ.';image.src=link.href;image.alt=link.querySelector('img')?.alt || 'Illustrative mantel assembly example';reset();savedOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();dialog.querySelector('[data-diagram-close]').focus();return true;}
 root.addEventListener('click',function(e){var link=e.target.closest('.lxc__combodiag');if(link&&open(link))e.preventDefault();});
 root.addEventListener('keydown',function(e){var link=e.target.closest('.lxc__combodiag');if(link&&e.key===' '&&open(link))e.preventDefault();});
 dialog.querySelector('[data-diagram-close]').addEventListener('click',function(){dialog.close();});
 dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
 dialog.addEventListener('close',function(){document.body.style.overflow=savedOverflow;reset();if(opener&&opener.isConnected)opener.focus({preventScroll:true});});
 toggle.addEventListener('click',function(){var on=dialog.classList.toggle('is-enlarged');toggle.setAttribute('aria-pressed',String(on));toggle.textContent=on?'Zoom out':'Zoom in';hint.textContent=(on?'Scroll to explore. ':'')+caption;media.scrollTop=0;media.scrollLeft=0;});
})();
/* Lexington color reference methods and manual shipping-label request. */
(function(){
 var root=document.getElementById('lxc-root'),dialog=document.getElementById('lxcSampleDialog');if(!root||!dialog)return;
 var opener=null;
 function update(){var choice=root.querySelector('input[name="lxc-color-method"]:checked'),physical=choice&&choice.value==='sample';root.querySelector('#lxc-color-photo-panel').hidden=physical;root.querySelector('#lxc-color-sample-panel').hidden=!physical;}
 root.querySelectorAll('input[name="lxc-color-method"]').forEach(function(input){input.addEventListener('change',update);});update();
 root.addEventListener('click',function(e){var trigger=e.target.closest('[data-lxc-sample-open]');if(!trigger)return;opener=trigger;var details=root.querySelector('#lxc-order-summary');document.getElementById('lxc-sample-product').value=details?details.textContent:document.title;dialog.showModal();});
 dialog.querySelector('[data-lxc-sample-close]').addEventListener('click',function(){dialog.close();});
 dialog.addEventListener('close',function(){if(opener)opener.focus();});
 if(dialog.querySelector('[data-lxc-sample-response]'))dialog.showModal();
})();


/* Lexington lightbox navigation uses the same doors lightbox and gallery instance. */
(function () {
  var lb = document.getElementById('ef-pd-lightbox'); if (!lb) return;
  var opener = null;
  function move(delta) {
    var g = window.EFGallery; if (!g) return;
    var slides = g.main.slides, count = slides.length, i = g.main.activeIndex;
    for (var n = 0; n < count; n++) {
      i = (i + delta + count) % count;
      var slide = slides[i], img = slide.dataset.mediaType === 'image' && slide.querySelector('img');
      if (img) { g.main.slideTo(i, 0); g.openLightbox(img.currentSrc || img.src, img.alt, i); return; }
    }
  }
  document.getElementById('ef-lb-prev').addEventListener('click', function () { move(-1); });
  document.getElementById('ef-lb-next').addEventListener('click', function () { move(1); });
  new MutationObserver(function () {
    var open = lb.classList.contains('ef-pd-lightbox--open');
    if (open && !opener) { opener = document.getElementById('efGalleryZoom'); document.getElementById('ef-lb-close').focus(); }
    else if (!open && opener) { opener.focus({preventScroll: true}); opener = null; }
  }).observe(lb, {attributes: true, attributeFilter: ['class']});
  lb.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); e.stopPropagation(); move(e.key === 'ArrowRight' ? 1 : -1); }
    if (e.key === 'Tab') { var buttons = [...lb.querySelectorAll('button')], i = buttons.indexOf(document.activeElement); e.preventDefault(); buttons[(i + (e.shiftKey ? -1 : 1) + buttons.length) % buttons.length].focus(); }
  });
})();
